<template lang="pug">
  info-card(title="Tempo assistido" icon="fas fa-clock")
    .card-body(slot="card-body")
      .flex-centered
        span.text-small ≅
        .h2.text-bold.ml-1 &nbsp;{{ Math.round(secondsWatched / 60) }}
        .h5.ml-1.mt-2 &nbsp;min
    .card-footer.text-center(slot="card-footer")
      cite.text-small Este é a quantidade aproximada de minutos que seus vídeos foram reproduzidos
</template>

<script>
export default {
  props: { secondsWatched: { type: [Number, String] } },
}
</script>
